import { useQuery } from '@apollo/client'
import { FETCH_CD_ACCOUNT_TRACK_DETAILS } from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import { makeStyles } from '@material-ui/core/styles'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { getFullName } from 'src/utils/commonMethods'
import { formatDateTime } from 'src/utils/commonMethods/formatDate'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import CloseButton from 'src/components/common/CloseButton'

const CdAccountTrack = ({ cdAccountId, setIsTrackModalOpen }) => {
  const classes = useStyles()

  const {
    loading: cdAccountTrackLoading,
    error: cdAccountTrackError,
    data: cdAccountTrackData,
  } = useQuery(FETCH_CD_ACCOUNT_TRACK_DETAILS(cdAccountId), {
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  })

  const transactionsList =
    cdAccountTrackData?.trackCdAccountsTransactions?.transactions

  if (cdAccountTrackError) {
    return <GraphQlErrors error={cdAccountTrackError} />
  }

  return (
    <>
      <LoadingModal loading={cdAccountTrackLoading} />
      <div className={classes.root}>
        <div className='modal-title-container'>
          <CloseButton
            title='Close'
            handleClose={() => {
              setIsTrackModalOpen(false)
            }}
            classname='modal-close-button'
          />
          <h2 className='modal-title'>Transactions</h2>
        </div>
        <TableContainer>
          <Table minWidth={650}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>CD A/C No.</TableCell>
                <TableCell className={classes.headerCell}>Balance</TableCell>
                <TableCell className={classes.headerCell}>Policies</TableCell>
                <TableCell className={classes.headerCell}>Updated By</TableCell>
                <TableCell className={classes.headerCell}>
                  Updated Timestamp
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactionsList?.map((row) => (
                <TableRow key={row?.id} className={classes.tableRow}>
                  <TableCell
                    className={classes.bodyCell}
                    component='th'
                    scope='row'
                  >
                    {row?.cdAccountNumber}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {formatToINR(row?.balance)}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row?.policyTypes?.join(', ')}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {getFullName([
                      row?.updatedBy?.firstName,
                      row?.updatedBy?.lastName,
                    ])}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {formatDateTime(row?.updatedOn)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  )
}

export default CdAccountTrack

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  heading: {
    textAlign: 'center',
    fontWeight: 'bold',
  },
  headerCell: {
    borderBottom: `2px solid ${theme.palette.divider}`,
    textAlign: 'center',
    padding: '10px',
  },
  bodyCell: {
    borderBottom: 'none',
    textAlign: 'center',
    padding: '5px',
  },
  tableRow: {
    '&:last-child td, &:last-child th': { border: 0 },
  },
}))
